module.exports = __webpack_public_path__ + "static/media/videos-1@2x.abc711c6.jpg";